<template>
  <div class="container">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Notes
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">
      <div class=" card-header">
        <div class="card-header-title">
          Notes
        </div>
      </div>
      <div class="card-content">
        <NotesList />
      </div>
    </div>

    <b-modal
      :active.sync="$store.state.noteEdit.isActive"
      has-modal-card
      width="960"
      :canCancel="[]"
    >
      <NoteEdit />
    </b-modal>

  </div>
</template>

<script>
import NotesList from "@/components/notes/NotesList.vue";
import NoteEdit from "@/components/notes/NoteEdit.vue";

export default {
  components: {
    NotesList,
    NoteEdit
  },

  props: {
    open: false
  }
};
</script>

<style>
</style>
